import {
  format,
  formatDistanceToNow,
  formatDistanceToNowStrict,
  intervalToDuration,
  isToday,
} from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export const formatDate = (date?: string): string => {
  if (!date) return "-";
  return format(new Date(date), "MMMM d, yyyy");
};

export const formatDateTime = (date?: string): string => {
  if (!date) return "-";
  return format(new Date(date), "MMMM d, yyyy, hh:mm a");
};

/** Compact 24h date-time used by admin tables/panels, e.g. "18 Jun 2026 14:30". */
export const formatDateTimeCompact = (date?: string | null): string => {
  if (!date) return "—";
  return format(new Date(date), "dd MMM yyyy HH:mm");
};

export const formatDateTimeUtc = (date?: string): string => {
  if (!date) return "-";
  return formatInTimeZone(new Date(date), "UTC", "MMM dd, yyyy HH:mm:ss 'UTC'");
};

export const getDistance = (date: Date, addSuffix = false) => {
  return formatDistanceToNowStrict(date, {
    addSuffix,
  })
    .replace(/ seconds?/, "s")
    .replace(/ minutes?/, "m")
    .replace(/ hours?/, "h")
    .replace(/ days?/, "d")
    .replace(/ months?/, "mo")
    .replace(/ years?/, "y");
};

export const formatRelativeTime = (
  dateString: string | undefined,
): string | null => {
  if (!dateString) return null;
  return formatDistanceToNow(new Date(dateString), { addSuffix: true });
};

export const formatDuration = (
  startedAt: string | undefined,
  completedAt: string | undefined,
): string | null => {
  if (!startedAt || !completedAt) return null;

  const duration = intervalToDuration({
    start: new Date(startedAt),
    end: new Date(completedAt),
  });

  const parts: string[] = [];
  if (duration.hours) parts.push(`${duration.hours}h`);
  if (duration.minutes) parts.push(`${duration.minutes}m`);
  parts.push(`${duration.seconds ?? 0}s`);

  return parts.join(" ");
};

export const getShortChatDate = (
  dateInput: string | Date | undefined,
): string => {
  if (!dateInput) return "";

  const date = new Date(dateInput);

  const time = format(date, "h:mm a");

  if (isToday(date)) {
    return time;
  }

  const distance = getDistance(date);

  return `${time} ${distance}`;
};
